<template>
  <div class="contract-list">
    <el-row class="filter-wrap" :gutter="20">
      <el-col :span="5">
        <el-input v-model="form.accountName" placeholder="账号名称" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="default" size="small" @click="onReset">重置</el-button>
        <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
      </el-col>
    </el-row>

    <div class="table-wrap">
      <div class="btn-text—flex">
        <div class="table-count">博主总数：{{ page.total }}条</div>
        <div>
          <el-badge v-if="type === 'ExamineProcessing'" style="margin:0 25px;" :value="multiSelectList.length" class="item">
            <el-button :disabled="multiSelectList.length>0?false:true" type="primary" size="small" @click="openDialog">批量审批</el-button>
          </el-badge>
        </div>
      </div>
      <el-table v-loading="tableLoading" :data="tableData" size="small"  @selection-change="handleSelectionChange">
      <template v-if="permissions.blogger_Show">
        <el-table-column
          v-if="platformValue !== 'black'"
          type="selection"
          width="55">
        </el-table-column>
      </template>
      <el-table-column type="selection"  width="55" align="center"></el-table-column>
      <el-table-column label="账号名称" width="150" prop="name">
        <template slot-scope="scope">
          <div class="account-wrap">
            <div class="info-wrap">
              <el-tooltip :content="scope.row.name" placement="bottom" effect="light">
                <div class="nickname"><span>{{ scope.row.name }}</span></div>
              </el-tooltip>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="粉丝数" align="center" prop="fansNum">
        <template slot-scope="scope">
          {{ checkNull(scope.row.fansNum) ? '--' : scope.row.fansNum }}
        </template>
      </el-table-column>
      <!-- 添加关联博主 -->
      <el-table-column label="关联博主" align="center" prop="fansNum">
        <template slot-scope="scope">
          <div v-if="scope.row.bloggerName">{{scope.row.bloggerName}}</div>
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column label="合作品牌" align="center" prop="brandSide">
        <template slot-scope="scope">
          <el-tooltip v-if="!checkNull(scope.row.brandSide)" :content="scope.row.brandSide" placement="bottom" effect="light" :popper-class="'overflow-content-tooltip'">
            <p class="overflow-content-wrap">{{ scope.row.brandSide }}</p>
          </el-tooltip>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="商务对接人" align="center" prop="businessList">
        <template slot-scope="scope">
          <span v-if="scope.row.businessName">{{scope.row.businessName}}</span>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="申请提交人" prop="applyUserName" align="center">
        </el-table-column>
      <el-table-column label="审批状态" prop="auditStatus" align="center">
          <template slot-scope="scope">
            <p>
              {{ approveConfig.getAppointed("statusQy", scope.row.auditStatus, "") }}
            </p>
          </template>
        </el-table-column>
        
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button v-if="type === 'ExamineProcessing'" type="text" size="small" @click="toAssess(scope.row.id,scope.row.mediaId,scope.row.mediaType)">审批</el-button>
            <el-button v-if="object===1&&(scope.row.status===2||scope.row.status===3)" type="text" size="small" @click="toAssess(scope.row.id,scope.row.mediaId,scope.row.mediaType)">重审</el-button>
            <el-button v-else-if="type === 'Processing'&&object===2" type="text" size="small" @click="toAssess(scope.row.id,scope.row.mediaId,scope.row.mediaType)">重审</el-button>
          </template>
        </el-table-column>
      </el-table>
        

      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination background @size-change="sizeChange" @current-change="currentChange" :current-page.sync="page.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="page.pageSize"
          layout="sizes, prev, pager, next, jumper" :total="page.total">
        </el-pagination>
      </div>
      <!-- 分页 -->
    </div>
    <el-dialog :title="dialogTitle" width="30%" :visible.sync="dialogTableVisible">
      <el-form v-if="dialogTitle==='批量审批'" label-position="left" :model="assessForm" ref="assessForm" label-width="100px" class="demo-ruleform">
        <el-form-item label="审批状态" prop="status" class="block-form-item w-99">
          <el-select v-model="assessForm.status" @change="statusChange">
            <el-option label="审批通过" value=1></el-option>
            <el-option label="审批不通过" value=0></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="assessForm.status == 0" label="原因" prop="notPassReason" class="block-form-item w-99">
          <el-input type="textarea" maxlength="300" show-word-limit v-model="assessForm.notPassReason"></el-input>
        </el-form-item>
        <div style="margin-top:20px;text-align:center;">
          <el-button type="primary" @click="batchClick()" style="margin-right:60px;">确 定</el-button>
          <el-button plain @click="dialogTableVisible = false">取 消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>

import validate from "@/util/validate";
import util from "@/util/util";
import { customConfig } from "@/const/config/custom";
import { approveConfig } from "@/const/config/approve";
import { mediaConfig } from "@/const/config/media";
import { mediaList,assessMediaBatch } from "@/api/approve/media";
import { mapGetters } from "vuex";
export default {
  props: ["type"],
  components: {
  },
  data() {
    return {
      object: null,
      customConfig: customConfig,
      approveConfig: approveConfig,

      form: {
        accountName: "",
      },

      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },

      tableData: [],
      tableLoading: false,
      classificationList:[],
      classificationType:'',
      fenleiVisible:false,
      multiSelectList:[],
      dialogTableVisible:false,
      dialogTitle:"",
      //审批
      assessForm: {
        ids:[] ,
        status: "1",
        notPassReason: "",
        auditRemark: "",
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    // 重置
    onReset() {
      this.form = {
        accountName: "",
      };
      this.onSearch();
    },
    // 搜索
    onSearch() {
      this.page.pageNum = 1;
      this.getList();
    },
    // 获取列表
    getList() {
      let queryObj = validate.removeFilterNull(this.form);
      queryObj.pageNum = this.page.pageNum;
      queryObj.pageSize = this.page.pageSize;
      queryObj.auditFlag = customConfig.Status[this.type];
      console.log("queryObj", queryObj);
      this.tableLoading = true;
      mediaList(queryObj)
        .then((res) => {
          this.tableData = res.data || [];
          this.page.total = res.total;
          this.object = res.object;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableData = [];
          this.page.total = 0;
          this.tableLoading = false;
        });
    },
    /**
     * 展示原因
     * @param text 原因类型
     * @param reason 原因
     */
    onShowReason(text, reason) {
      reason = reason || "原因";
      text = text || "";
      this.$alert(text, reason, {
        showConfirmButton: false,
        closeOnClickModal: true,
        customClass: "msgbox",
        callback: (action) => {},
      });
    },
    /**
     * 跳转到审批页
     */
    toAssess(id,mediaId,mediaType) {
      let router = this.$router.push({
        path: "/check/media/assess",
        query: {
          mediaId,
          mediaType,
          id,
        },
      });
      window.open(router.href, "_blank");
      window.open("about:blank","_self").close()
      window.close();//关闭当前页面
    },

    //选择
    handleSelectionChange(val){
      this.multiSelectList = val;
    },

    //打开调整输入框
    openDialog(obj){
      this.dialogTitle = '批量审批' ;
      this.dialogTableVisible = true ;
      console.log("======"+obj);
    },

    //批量审批
    batchClick(){
      console.log(this.multiSelectList) ;
      var ids = []
      this.multiSelectList.forEach(element => {
        ids.push(element.id)
      });
      this.assessForm.ids = ids ;
      console.log(ids) ;
      let obj = {};
      obj.ids = ids;
      obj.isPass = parseInt(this.assessForm.status);
      obj.notPassReason = this.assessForm.notPassReason; //审批失败原因
      obj.auditRemark = this.assessForm.auditRemark;
      assessMediaBatch(obj)
        .then((res) => {
            this.$message.success("审批成功");
            this.dialogTableVisible = false
            this.getList();
        })
        .catch((error) => {
          this.dialogTableVisible = false
        });
    },

    //审批状态改变
    statusChange(val) {
      this.assessForm.notPassReason = "";
    },

    
    /**
     * 数字可读化
     * @param num 数字
     */
    readableNum(num) {
      if (!num && num !== 0) return "";
      return util.priceFormat(num);
    },
    //分类数据
    classificationDetails(data,type){
      this.fenleiVisible = true;
      this.classificationList = data;
      this.classificationType = type;
      console.log('====数据======',data)
    },
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
};
</script>

<style lang="scss" scoped>
//抽屉样式影响处理
.el-table::before{
  z-index: 0 !important;
}
.table-count {
  margin: 20px 0 15px;
  font-size: 14px;
}
.media-table {
  //账号名称
  .account-wrap {
    display: flex;
    cursor: pointer;
    //头像
    .avatar-out {
      /*width: 50%;*/
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .avatar-in {
        position: relative;
        width: 42px;
        height: 42px;
        margin-right: 10px;
        float: right;
        .img-wrap {
          position: relative;
          border-radius: 50%;
          width: 42px;
          height: 42px;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            &.is-code {
              position: absolute;
              top: -84px;
              left: -84px;
              width: 210px;
              height: 210px;
            }
          }
        }
      }
    }
    //基础信息
    .info-wrap {
      display: flex;
      align-items: center;
      width: 50%;
      font-size: 12px;
      text-align: left;
      .nickname {
        max-width: 65px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  //分类项
  .category-item {
    display: inline-block;
    margin: 3px;
    font-size: 12px;
  }
  //更多价格
  .more-price {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    cursor: pointer;
    .iconfont {
      margin-right: 5px;
      font-weight: bold;
    }
  }
}
</style>

<style lang="scss">
.overflow-content {
  &-wrap {
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    line-clamp: 4;
    -webkit-box-orient: vertical;
  }
  &-tooltip {
    max-width: 400px !important;
  }
}
.table-count-wrap {
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.btn-text—flex{
  margin: 15px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
